import { c as _c } from "react/compiler-runtime";
import { useAuth } from "../../hooks/use-auth";
import ResetPasswordCard from "./ResetPasswordCard";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ResetPasswordView(t0) {
  const $ = _c(13);
  const {
    authClient,
    onSuccess,
    onBackToSignIn,
    token,
    statusMessage,
    onStatusMessageAction,
    statusMessageActionLabel
  } = t0;
  let t1;
  if ($[0] !== authClient) {
    t1 = {
      authClient
    };
    $[0] = authClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    resetPassword,
    isUpdating
  } = useAuth(t1);
  let t2;
  if ($[2] !== onSuccess || $[3] !== resetPassword || $[4] !== token) {
    t2 = async password => {
      if (!token) {
        return {
          success: false,
          message: "\xC5terst\xE4llningsl\xE4nken saknar token. Beg\xE4r en ny l\xE4nk."
        };
      }
      const response = await resetPassword(token, password);
      if (response.success && onSuccess) {
        onSuccess();
      }
      return response;
    };
    $[2] = onSuccess;
    $[3] = resetPassword;
    $[4] = token;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleResetPassword = t2;
  let t3;
  if ($[6] !== handleResetPassword || $[7] !== isUpdating || $[8] !== onBackToSignIn || $[9] !== onStatusMessageAction || $[10] !== statusMessage || $[11] !== statusMessageActionLabel) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "bg-background sm:flex sm:grow sm:items-start sm:justify-center sm:px-4 lg:px-0",
      children: /*#__PURE__*/_jsx(ResetPasswordCard, {
        onSubmit: handleResetPassword,
        onBackToSignIn: onBackToSignIn,
        loading: isUpdating,
        statusMessage: statusMessage,
        onStatusMessageAction: onStatusMessageAction,
        statusMessageActionLabel: statusMessageActionLabel
      })
    });
    $[6] = handleResetPassword;
    $[7] = isUpdating;
    $[8] = onBackToSignIn;
    $[9] = onStatusMessageAction;
    $[10] = statusMessage;
    $[11] = statusMessageActionLabel;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}